var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 62,
  viewBox: "0 0 50 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 48,
  height: 60,
  rx: 5,
  stroke: "currentColor",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5335 37.548C19.7915 36.6036 20.6234 35.9927 21.4352 36.0064C21.7912 35.9995 23.3544 35.9995 24.9981 36.0004C26.6418 35.9995 28.205 35.9995 28.561 36.0064C29.3728 35.9927 30.2047 36.6036 30.4628 37.548L31.097 39.8725C31.5562 39.8982 31.9219 40.272 31.9219 40.73C31.9219 41.0299 31.7644 41.2946 31.5265 41.4484C31.816 41.7036 31.9962 42.0568 31.9962 42.4512V43.7402C31.9962 43.9413 31.949 44.1312 31.8659 44.3005C31.7688 44.4913 31.7732 44.7164 31.8764 44.9037C31.9551 45.0343 31.9962 45.1882 31.9962 45.3514C31.9962 45.8481 31.6131 46.258 31.1215 46.3121V46.7478C31.1215 47.4585 30.5336 48.0368 29.8093 48.0368C29.085 48.0368 28.4972 47.4585 28.4972 46.7478V46.3572H21.4991V46.7478C21.4991 47.4585 20.9112 48.0368 20.1869 48.0368C19.4626 48.0368 18.8748 47.4585 18.8748 46.7478V46.3121C18.3831 46.258 18 45.8481 18 45.3514C18 45.1882 18.0411 45.0352 18.1137 44.9003C18.2152 44.7147 18.2187 44.493 18.1225 44.3039C18.0472 44.1312 18 43.9404 18 43.7402V42.4512C18 42.0637 18.1741 41.7165 18.4488 41.4802C18.1811 41.3333 18 41.0523 18 40.73C18 40.2557 18.3919 39.8716 18.8739 39.8716L19.5335 37.548ZM20.6563 42.8581C21.1199 42.8581 21.4961 43.2343 21.4961 43.6979C21.4961 44.1615 21.1199 44.5377 20.6563 44.5377C20.1928 44.5377 19.8166 44.1615 19.8166 43.6979C19.8166 43.2343 20.1928 42.8581 20.6563 42.8581ZM29.3368 42.8581C29.8004 42.8581 30.1766 43.2343 30.1766 43.6979C30.1766 44.1615 29.8004 44.5377 29.3368 44.5377C28.8733 44.5377 28.4971 44.1615 28.4971 43.6979C28.4971 43.2343 28.8733 42.8581 29.3368 42.8581ZM28.4972 41.0386H28.9426C29.108 41.0386 29.2647 40.9639 29.3653 40.8379C29.4668 40.7119 29.5001 40.5473 29.4572 40.3937C29.2647 39.7017 28.9637 38.6259 28.8053 38.0582C28.7431 37.8349 28.5313 37.6795 28.2898 37.6795H24.9967H21.7036C21.4621 37.6795 21.2503 37.8349 21.1882 38.0582C21.0298 38.6259 20.7287 39.7017 20.5362 40.3937C20.4933 40.5473 20.5266 40.7119 20.6281 40.8379C20.7287 40.9639 20.8854 41.0386 21.0508 41.0386H21.4962C22.0055 41.0369 27.9879 41.0369 28.4972 41.0386Z",
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 16,
  width: 22,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 22,
  width: 16,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 10,
  width: 30,
  height: 2,
  rx: 1,
  fill: "currentColor"
})));
export { SvgPts as ReactComponent };